import Enumerable from "linq";
import { ProgressConditionKinds, ProgressConditionKindsName } from "../kinds";
import { WorkflowPhaseEditorModel } from ".";

// WFルート設定
export class WorkflowRouteEditorModel {
  public progressCondition: ProgressConditionKinds = ProgressConditionKinds.None;
  public phases: WorkflowPhaseEditorModel[];
  public isPaper: boolean;
  
  // パターン選択のマスタ取得時のみ使用
  public id: number;
  // パターン選択のマスタ取得時のみ使用
  public name: string;

  get progressConditionName(): string {
    return ProgressConditionKindsName.getDisplayName(this.progressCondition);
  }

  clone(): WorkflowRouteEditorModel {
    const newObj = new WorkflowRouteEditorModel();
    newObj.progressCondition = this.progressCondition;
    newObj.phases = Enumerable.from(this.phases)
      .select(p => p.clone())
      .toArray();
    newObj.isPaper = this.isPaper;
    newObj.name = this.name;

    return newObj;
  }
}
